import { createHashHistory } from 'history';
import { kebabCase } from 'lodash';
import { Nav, NavItem, NavLink, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import React from 'react';
import PropTypes from 'prop-types';
import { hasSummaryPermissions } from '../../common/classes/permissions';
const hashHistory = createHashHistory();
const SummariesListPanel = _ref => {
  let summariesList = _ref.summariesList,
    _ref$section = _ref.section,
    section = _ref$section === void 0 ? '' : _ref$section;
  const handleSelect = key => hashHistory.replace("/admin/summaries/".concat(key));
  let preSelected = '';
  const summaryListItems = summariesList.map((summary, index) => {
    if (hasSummaryPermissions(summary.identifier)) {
      // select the first summary by default
      if (preSelected === '') {
        preSelected = summary.id;
      }
      return /*#__PURE__*/React.createElement(NavItem, {
        className: "t-nav-section-".concat(kebabCase(summary.identifier)),
        key: "nav_".concat(summary.identifier),
        active: section.length > 0 ? summary.id === section : index === 0
      }, /*#__PURE__*/React.createElement(NavLink, {
        onClick: () => handleSelect(summary.id)
      }, summary.name));
    }
    return null;
  });
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement("h3", {
    className: "t-slp-summary-section"
  }, "Summaries")))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Nav, {
    pills: true,
    vertical: true,
    onSelect: () => handleSelect(section || preSelected)
  }, summaryListItems)));
};
SummariesListPanel.propTypes = {
  section: PropTypes.string,
  summariesList: PropTypes.arrayOf(PropTypes.shape({
    identifier: PropTypes.string
  })).isRequired
};
export default SummariesListPanel;